goog.provide("shadow.js.shim.module$src$svg$artwork$map_svg");
goog.provide("module$shadow_js_shim_module$src$svg$artwork$map_svg");
shadow.js.shim.module$src$svg$artwork$map_svg = shadow.js.nativeProvides["src/svg/artwork/map.svg"] = shadow$bridge("src/svg/artwork/map.svg");
module$shadow_js_shim_module$src$svg$artwork$map_svg.default = shadow.js.shim.module$src$svg$artwork$map_svg;
